export default function DashboardWorkListLoading() {
  return (
    <div className="mx-auto flex w-full max-w-[1020px] flex-col gap-6">
      <div className="bg-secondary h-6 w-48 animate-pulse rounded-lg" />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="flex flex-col gap-4 rounded-2xl p-2 pb-4">
            <div className="bg-tertiary aspect-video animate-pulse rounded-lg" />
            <div className="flex flex-col gap-2 px-2">
              <div className="bg-secondary h-5 w-3/4 animate-pulse rounded-lg" />
              <div className="bg-secondary h-4 w-1/2 animate-pulse rounded-lg" />
              <div className="bg-secondary h-4 w-2/5 animate-pulse rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
